module.exports = __webpack_public_path__ + "img/tegbc.f470ea88.png";